export function distanceBetweenTranslations2D(matrix1: DOMMatrix, matrix2: DOMMatrix) {
  const dx = matrix1.e - matrix2.e;
  const dy = matrix1.f - matrix2.f;
  return Math.sqrt(dx * dx + dy * dy);
}

export function angleBetweenMatrices(matrix1: DOMMatrix, matrix2: DOMMatrix): number {
  const dx = matrix2.e - matrix1.e;
  const dy = matrix2.f - matrix1.f;
  return (Math.atan2(dy, dx) * 180) / Math.PI;
}

export function matrixRotationInDegrees(matrix: DOMMatrix) {
  // Use m12 (sin(theta)) and m11 (cos(theta)) for atan2
  const radians = Math.atan2(matrix.m12, matrix.m11);

  // Convert radians to degrees
  let degrees = radians * (180 / Math.PI);

  // Optional: Adjust to a positive 0-360 range if needed
  if (degrees < 0) {
    degrees += 360;
  }

  return degrees;
}

export function matrixScale(matrix: DOMMatrix) {
  return Math.sqrt(matrix.m11 * matrix.m11 + matrix.m12 * matrix.m12);
}

export function getDomMatrixAt(x: number, y: number) {
  return new DOMMatrix([1, 0, 0, 1, x, y]);
}

export function getDomMatrixFromStyles(el: HTMLDivElement) {
  // gets the matrix directly from the style tag and falls back to a default transform at 0, 0
  return new DOMMatrix(el.style.transform ?? [1, 0, 0, 1, 0, 0]);
}

export function applyTransform(el: HTMLDivElement, matrix: DOMMatrix) {
  el.style.setProperty('transform', matrix.toString());
}
